var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 65,
    viewBox: "0 0 64 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61.9096 9.31046L54.667 8.22408L51.3626 2L48.0582 8.22408L40.6685 9.31046L46.0099 14.5161L44.7424 21.8265L51.3513 18.375L57.9601 21.8265L56.6927 14.5161L61.9096 9.31046ZM23.3656 9.31046L15.9759 8.22408L12.6715 2L9.36704 8.22408L2 9.31046L7.31876 14.5161L6.05131 21.8265L12.6601 18.375L19.269 21.8265L18.0015 14.5161L23.3656 9.31046Z",
    fill: "#FFB62A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0133 14.5161L19.2807 21.8265L12.6719 18.375V2L15.9763 8.22408L23.366 9.31046L18.0133 14.5161Z",
    fill: "#FFB62A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5697 26.6133C41.5852 26.6133 40.8156 25.8438 40.8156 24.8593V23.1052H23.2185V24.8593C23.2185 25.8438 22.4489 26.6133 21.4644 26.6133H16.1909V42.1283C16.1909 51.4531 22.5168 59.6123 31.5927 61.8982L32.0114 62.0001L32.4301 61.8982C41.5059 59.6123 47.8319 51.4418 47.8319 42.1283V26.6133H42.5697Z",
    fill: "#F2F2F2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M47.8434 26.6132V42.1281C47.8434 51.4529 41.5175 59.6121 32.4417 61.898L32.0229 61.9999V23.0938H40.8159V24.8478C40.8159 25.8323 41.5854 26.6019 42.5699 26.6019H47.8434V26.6132Z",
    fill: "#E7E7F2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5697 30.1327C40.2838 30.1327 38.3147 28.6503 37.6131 26.6133H26.4324C26.0719 27.6407 25.4016 28.531 24.5138 29.1613C23.626 29.7917 22.5645 30.1311 21.4757 30.1327H19.7217V42.1395C19.7217 49.699 24.7462 56.3531 32.034 58.4013C39.3105 56.3644 44.3464 49.699 44.3464 42.1395V30.1327H42.5697Z",
    fill: "#5ACAF4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M44.3236 30.1327V42.1395C44.3236 49.699 39.2991 56.3531 32.0112 58.4013V26.6133H37.6016C38.3032 28.6503 40.2723 30.1327 42.5582 30.1327H44.3236Z",
    fill: "#5ACAF4"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M42.7056 9.31046L35.3159 8.22408L32.0115 2L28.7071 8.22408L21.3174 9.31046L26.6588 14.5161L25.3913 21.8265L32.0002 18.375L38.609 21.8265L37.3416 14.5161L42.7056 9.31046Z",
    fill: "#FFB62A"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5184 40.2722L32.0114 46.8131L30.2573 48.5672L25.5044 43.7803L27.9714 41.3133L30.2573 43.5653L32.0114 41.8112L36.0514 37.8052L38.5184 40.2722Z",
    fill: "#F2F2F2"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M38.6201 21.8265L32.0112 18.375V2L35.3157 8.22408L42.7053 9.31046L37.3639 14.5161L38.6201 21.8265Z",
    fill: "#FFB62A"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5182 40.2723L32.0112 46.8133V41.8227L36.0512 37.8167L38.5182 40.2723Z",
    fill: "#E7E7F2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoe);
export default __webpack_public_path__ + "static/media/yoe.250bc6207a953a22f3fb826653bf7d4d.svg";
export { ForwardRef as ReactComponent };